import Config from '@/config'

const IconInfo = {
	methods: {
		decode(type, value) {
			// Decode icon to be used from type and value
			if (type === 'type' && value === Config.NOTIFICATION_TYPE_GENERIC) {
				return 'fa fa-newspaper-o'
			} else if (type === 'type' && value === Config.NOTIFICATION_TYPE_FROM_ADMIN) {
				return 'fa fa-info'
			} else if (type === 'type' && value === Config.NOTIFICATION_TYPE_ACCOUNT) {
				return 'fa fa-user'
			} else if (type === 'type' && value === Config.NOTIFICATION_TYPE_MONEY) {
				return 'fa fa-money'
			} else if (type === 'type' && value === Config.NOTIFICATION_TYPE_REQUEST) {
				return 'fa fa-handshake-o'
			} else if (type === 'priority' && value === Config.NOTIFICATION_PRIORITY_NONE) {
				return 'fa fa-circle'
			} else if (type === 'priority' && value === Config.NOTIFICATION_PRIORITY_LOW) {
				return 'fa fa-arrow-circle-down'
			} else if (type === 'priority' && value === Config.NOTIFICATION_PRIORITY_MEDIUM) {
				return 'fa fa-minus-circle'
			} else if (type === 'priority' && value === Config.NOTIFICATION_PRIORITY_HIGH) {
				return 'fa fa-arrow-circle-up'
			} else if (type === 'status' && value === 'saved') {
				return 'fa fa-bookmark'
			} else if (type === 'status' && value === 'unsaved') {
				return 'fa fa-bookmark-o'
			} else if (type === 'status' && value === 'read') {
				return 'fa fa-eye'
			} else if (type === 'status' && value === 'unread') {
				return 'fa fa-eye-slash'
			} else if (type === 'status' && value === 'closed') {
				return 'fa fa-lock'
			} else if (type === 'status' && value === 'open') {
				return 'fa fa-hourglass'
			} else if (type === 'status' && value === 'approved') {
				return 'fa fa-trophy'
			} else if (type === 'status' && value === 'refunded') {
				return 'fa fa-shopping-bag'
			} else if (type === 'status' && value === 'retired') {
				return 'fa fa-trash'
			} else if (type === 'status' && value === 'invalid') {
				return 'fa fa-ban'
			} else if (type === 'status' && value === 'incomplete') {
				return 'fa fa-edit'
			} else if (type === 'status' && value === 'new') {
				return 'fa fa-folder-open'
			} else if (type === 'status' && value === 'init') {
				return 'fa fa-cogs'
			} else if (type === 'status' && value === 'rejected') {
				return 'fa fa-window-close-o'
			} else if (type === 'plan' && value === Config.REQUEST_PLAN_BASIC) {
				return 'fa fa-user'
			} else if (type === 'plan' && value === Config.REQUEST_PLAN_FREE) {
				return 'fa fa-user'
			} else if (type === 'plan' && value === Config.REQUEST_PLAN_PREMIUM) {
				return 'fa fa-group'
			} else if (type === 'plan' && value === Config.REQUEST_PLAN_TOP) {
				return 'fa fa-gift'
			} else if (type === 'request_status' && value === Config.REQUEST_STATUS_CLOSED) {
				return 'fa fa-lock'
			} else if (type === 'request_status' && value === Config.REQUEST_STATUS_INIT) {
				return 'fa fa-cogs'
			} else if (type === 'request_status' && value === Config.REQUEST_STATUS_NEW) {
				return 'fa fa-folder-open'
			} else if (type === 'request_status' && value === Config.REQUEST_STATUS_WAIT) {
				return 'fa fa-hourglass'
			} else if (type === 'request_status' && value === Config.REQUEST_STATUS_APPROVED) {
				return 'fa fa-trophy'
			} else if (type === 'request_status' && value === Config.REQUEST_STATUS_INCOMPLETE) {
				return 'fa fa-edit'
			} else if (type === 'request_status' && value === Config.REQUEST_STATUS_REFUNDED) {
				return 'fa fa-shopping-bag'
			} else if (type === 'request_status' && value === Config.REQUEST_STATUS_RETIRED) {
				return 'fa fa-trash'
			} else if (
				type === 'request_status' &&
				(value === Config.REQUEST_STATUS_REJECTED_1 ||
					value === Config.REQUEST_STATUS_REJECTED_2 ||
					value === Config.REQUEST_STATUS_REJECTED_3 ||
					value === Config.REQUEST_STATUS_REJECTED_WITH_REPLY)
			) {
				return 'fa fa-window-close-o'
			} else if (type === 'request_status' && value == Config.CUSTOM_REQUEST_STATUS_LOST) {
				return 'fa fa-frown-o'
			} else if (type === 'response_status' && value === Config.RESPONSE_STATUS_PENDING) {
				return 'fa fa-hourglass'
			} else if (type === 'response_status' && value === Config.RESPONSE_STATUS_NEW) {
				return 'fa fa-hourglass'
			} else if (type === 'response_status' && value === Config.RESPONSE_STATUS_OK) {
				return 'fa fa-thumbs-up'
			} else if (type === 'response_status' && value === Config.RESPONSE_STATUS_WAIT) {
				return 'fa fa-hourglass'
			} else if (type === 'response_status' && value === Config.RESPONSE_STATUS_KO) {
				return 'fa fa-thumbs-down'
			} else if (type === 'response_status' && value === Config.RESPONSE_STATUS_APPROVED) {
				return 'fa fa-trophy'
			}
		},
	},
}

export default IconInfo



// WEBPACK FOOTER //
// ./src/mixins/IconInfo.js